import { __extends } from "tslib";
import { clone } from '@antv/util';
import ColumnLabel from '../../column/component/label';
var StackColumnLabel = /** @class */ (function (_super) {
    __extends(StackColumnLabel, _super);
    function StackColumnLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackColumnLabel.prototype.getDefaultOptions = function () {
        var theme = this.plot.theme;
        var labelStyle = theme.label.style;
        return {
            offsetX: 0,
            offsetY: 0,
            style: clone(labelStyle),
            adjustPosition: true,
        };
    };
    StackColumnLabel.prototype.adjustLabel = function (label, shape) {
        if (this.options.adjustPosition) {
            var labelRange = label.getBBox();
            var shapeRange = this.getShapeBbox(shape);
            if (shapeRange.height <= labelRange.height) {
                label.attr('text', '');
            }
        }
    };
    return StackColumnLabel;
}(ColumnLabel));
export default StackColumnLabel;
//# sourceMappingURL=label.js.map